// extracted by mini-css-extract-plugin
module.exports = {"logoLink":"h3","logoWrapper":"h4"};